const styles = theme => ({
  grid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    height: '360px',
    flexBasis: 'unset',
    borderRadius: '10px',
    marginBottom: '20px',
    backgroundColor: 'rgb(145,158,171,0.08)',
  },
  gridViewImage: {
    width: '100%',
    flexBasis: 'unset',
    height: 360,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    /* '&::after': {
      content: '" "',
      backgroundColor: '#F4F6F8',
      width: '640px',
      height: '240px',
      display: 'block',
      position: 'absolute',
      top: 60,
      zIndex: 0,
      borderRadius: 16,
    }, */
  },
  imagePlaceholder: {
    marginBottom: theme.spacing(1.5),
    margin: '0 auto',
    justifyContent: 'center',
    marginTop: theme.spacing(1.5),
    alignItems: 'center',
  },

  informGrid: {
    minWidth: 130,
  },
  card: {
    width: '100%',
    maxWidth: 120,
    minHeight: 150,
    marginBottom: theme.spacing(1.5),
    marginRight: theme.spacing(1.5),
  },
  media: {
    height: 60,
    width: 60,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 10,
    marginBottom: 0,
  },
  cardContent: {
    textAlign: 'center',
  },
  button: {
    borderColor: '#0C53B7',
    background: '#0C53B7',
    color: 'white',
    textTransform: 'none',
    marginBottom: theme.spacing(2),
    '&:hover': {
      borderColor: '#0c72ce',
      background: '#0c72ce',
      color: 'white',
    },
  },

  or: {
    color: 'white',
    margin: theme.spacing(1),
  },
  box: {
    width: 162,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignItems: 'center',
  },
  deleteButton: {
    position: 'absolute',
    zIndex: 1300,
  },

  addImage: {
    borderColor: '#0C53B7',
    background: '#0C53B7',
    color: 'white',
    textTransform: 'none',
    margin: theme.spacing(1),
    '&:hover': {
      borderColor: '#0c72ce',
      background: '#0c72ce',
      color: 'white',
    },
  },
  iconButton: {
    position: 'absolute',
    right: '15px',
    top: '15px',
    zIndex: 2,
    backgroundColor: 'rgba(255,255,255,0.1)',
  },
  img: {
    maxHeight: 360,
    margin: '0 auto',
  },
  imgGrid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '16px',
    marginTop: '16px',
  },
})

export default styles
